import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  const [catGifUrl, setCatGifUrl] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://cataas.com/cat/gif')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch cat GIF');
        }
        setCatGifUrl(response.url);
      })
      .catch(err => {
        console.error("Error fetching cat GIF:", err);
        setError(err.message);
      });
  }, []);

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat px-4"
    >
      <div className="max-w-lg mx-auto mt-6 bg-white bg-opacity-90 rounded-2xl shadow-lg p-6 text-center">
        <h1 className="text-4xl font-bold text-green-900 mb-4 drop-shadow-md">
          Cat-strophic Error
        </h1>
        <p className="text-gray-700 text-lg mb-6">
          This page doesn’t exist… but here’s a random cat GIF to make it better.
        </p>

        <div className="flex justify-center items-center min-h-[200px] mb-4">
          {error ? (
            <p className="text-red-500">{`Error loading cat GIF: ${error}`}</p>
          ) : catGifUrl ? (
            <img
              src={catGifUrl}
              alt="Random Cat GIF"
              className="rounded-md max-h-80 shadow-md"
            />
          ) : (
            <p className="text-gray-500">Loading cat GIF...</p>
          )}
        </div>

        <Link
          to="/"
          className="inline-block mt-2 px-6 py-3 text-white bg-green-700 hover:bg-green-800 rounded-md transition"
        >
          Take me home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
